module.exports = __webpack_public_path__ + "img/aa5b9b8.png";